import * as React from 'react';
// import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {NavLink} from "react-router-dom";

const toTest = (to, path, exact) => (exact !== undefined ? path : path.substr(0, to.length)) === to;

const HoC = ({path, className, to, exact, activeClass, dispatch, ...props}) => {
	return (
		<NavLink to={to} exact={exact} className={`${toTest(to,path, exact) ? activeClass : ''}`} {...props}/>
	);
};
HoC.defaultProps = {
	path: '/',
	activeClass: 'active',
	activeClassName: null
};

const m2s = state => {
	// console.info('State,,, path', state.router);
	// let path = '/';
	// try { path = state.router.location.pathname; } catch(e) { path = '/'; console.error('MY ERROR') }
	// console.info('path', path);
	return {
		path: state.router.location.pathname
	};
};

export default connect(m2s)(HoC);


// WEBPACK FOOTER //
// ./src/containers/NavLink.js